export default __webpack_public_path__ + "static/sol-k12-section-4-img-82f762521aa7c0ddd8c1238ee3c70c76.png";